import { createContext } from "react";

export type Language = "en" | "mi";

export interface LanguageContextValue {
    language: Language;
    toggleLanguage: () => void;
}

export const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
